import React from 'react'

import { useLoadImage } from 'utils/hooks/useLoadImage'

import Badges from './Badges'
import { ImageWrapper } from './styles/ImageWrapper'
import { StyledDotLoader } from './styles/StyledDotLoader'

interface Props {
  src: string
  hover: boolean
  badges: string[]
}

function Image({ src, hover, badges }: Props) {
  const { isImageLoading } = useLoadImage({ src })

  if (isImageLoading) {
    return <StyledDotLoader />
  }

  return (
    <ImageWrapper
      src={src}
      hover={hover}
      data-testid="ImgNode"
    >
      <Badges badges={badges} />
    </ImageWrapper>
  )
}

export default Image
